module.exports = __webpack_public_path__ + "img/logo.4a829596.svg";